// Shared host container for CodeMirror tooltip portals.
// Keeps per-editor tooltip host nodes out of the main page layout.
let sharedTooltipHost: HTMLElement | null = null;

export function getSharedTooltipHost(): HTMLElement {
  if (!sharedTooltipHost) {
    const host = document.createElement("div");
    host.id = "cm-shared-tooltip-host";
    host.style.position = "fixed";
    host.style.top = "0";
    host.style.left = "0";
    host.style.width = "0";
    host.style.height = "0";
    host.style.overflow = "visible";
    host.style.pointerEvents = "none";
    host.style.zIndex = "99999";
    document.body.appendChild(host);
    sharedTooltipHost = host;
  }

  return sharedTooltipHost;
}
